<template>
  <div id="app" :class="{isDownload: submitPass, app: true}">
    <header>
      <img src="./assets/img/logo.png" alt="">
    </header>
    <div class="content">
      <template v-if="!submitPass">
        <!-- <div class="item">
          <img src="./assets/img/icon1.png" alt="" >
          <input type="text" placeholder="Enter UserName" v-model="userName">
        </div> -->
		  <div class="item mb5">
		    <img src="./assets/img/icon3.png" alt="">
		      &nbsp; +91
		    <input type="number" placeholder="Enter phone number" v-model="phoneNo" maxlength="10" :disabled="!!count" :class="!!count ? 'disabled' : ''"/>
		  </div>
      <p class="tip">Please enter 10 digit phone number</p>
      
      <div class="item mb5">
        <img src="./assets/img/icon6.png" alt="">
        <input type="text" placeholder="Enter Password" v-model="passwd" >
      </div>
      <p class="tip">Please enter 6 - 20 characters</p>
      
      <div class="item imageCode">
        <img class="row-icon" src="./assets/img/icon1.png" alt="">
        <input type="text" inputmode="text" autocomplete="off" placeholder="Enter image code" v-model="captcha">
        <div class="captcha-side">
          <img v-if="captchaImageUrl" class="captcha-img" :src="captchaImageUrl" alt="captcha" @click="loadCaptcha">
          <span @click="loadCaptcha" class="captcha-refresh">Refresh</span>
        </div>
      </div>

      <div class="item optCode">
		    <img src="./assets/img/icon3.png" alt="">
		    <input type="number" placeholder="Enter otp code" v-model="smsOtp">
        <span @click="getCode" :class="!!count ? 'disabled' : ''">
          {{ count === null ? 'Send' : `${count} s` }}
        </span>
		  </div>
        <div class="item">
          <img src="./assets/img/icon1.png" alt="">
          <input type="text" placeholder="Enter invite code" v-model="inviteCode">
        </div>
        <div class="item" @click="submitData">Register</div>
        
      </template>
      <div v-else class="item">
        <a :href="h5Url">Download</a>
      </div>
    </div>

    <!-- Google reCAPTCHA 弹层：点击 Send 后展示 -->
    <div class="recaptcha-modal" v-show="showRecaptcha">
      <div class="recaptcha-mask" @click="closeRecaptcha"></div>
      <div class="recaptcha-panel">
        <div class="recaptcha-title">Security verification</div>
        <div class="recaptcha-container">
          <div id="google-recaptcha"></div>
        </div>
        <div class="recaptcha-actions">
          <button class="recaptcha-btn cancel" type="button" @click="closeRecaptcha">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast ,Dialog,Loading  } from 'vant-green';
import { registerUser, sendVerCodeV2, getCaptcha } from "./assets/api/common"

export default {
  name: 'App',
  components: {},
  data () {
    return {
      submitPass: false,
      userName:null,
      phoneNo:null,
      passwd:null,
      optCode: null,
      inviteCode:null,
      smsOtp:null,
      captcha: '',
      captchaToken: null,
      captchaImageUrl: '',
      googleRecaptchaToken: '',
      googleRecaptchaWidgetId: null,
      showRecaptcha: false,
      pendingSendOtpAfterRecaptcha: false,
      h5Url:null,
      count: null,
      timer: null
    }
  },
  mounted() {
    this.loadCaptcha();
    this.initGoogleRecaptcha();
	  
    const params = Object.create(null);
    let { href } = location;
    href.slice(href.indexOf('?') + 1).split('&').map(t => {
      let [k, v] = t.split('=');
      params[k] = v;
    });
	  
    this.orderUrl = location.href;
    console.info(this.orderUrl);
    var inviteCode1 = params["inviteCode"];
    this.$nextTick(_ => {
      this.inviteCode=inviteCode1;
    })
  },
  beforeDestroy () {
    if (this.captchaImageUrl) {
      URL.revokeObjectURL(this.captchaImageUrl)
    }
    if (typeof window !== 'undefined' && window.grecaptcha && this.googleRecaptchaWidgetId !== null) {
      try {
        window.grecaptcha.reset(this.googleRecaptchaWidgetId)
      } catch (e) {}
    }
  },


 methods:{
  initGoogleRecaptcha () {
    const siteKey = '6LdxU8ssAAAAAM-_00DGvK0JXmMC3EpkYLo1N66P'
    if (typeof window === 'undefined') return

    // If already loaded, render directly.
    if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
      // 弹层打开时再渲染（避免页面上常驻展示）
      if (this.showRecaptcha) this.renderGoogleRecaptcha(siteKey)
      return
    }

    // Avoid injecting script multiple times.
    if (document.querySelector('script[data-google-recaptcha]')) return

    window.__onGoogleRecaptchaLoaded = () => {
      if (this.showRecaptcha) this.renderGoogleRecaptcha(siteKey)
    }

    const s = document.createElement('script')
    s.src = 'https://www.google.com/recaptcha/api.js?onload=__onGoogleRecaptchaLoaded&render=explicit'
    s.async = true
    s.defer = true
    s.setAttribute('data-google-recaptcha', '1')
    document.head.appendChild(s)
  },

  renderGoogleRecaptcha (siteKey) {
    if (!window.grecaptcha || typeof window.grecaptcha.render !== 'function') return
    const el = document.getElementById('google-recaptcha')
    if (!el) return

    // If already rendered once, just reset.
    if (this.googleRecaptchaWidgetId !== null) {
      try {
        window.grecaptcha.reset(this.googleRecaptchaWidgetId)
        this.googleRecaptchaToken = ''
      } catch (e) {}
      return
    }

    this.googleRecaptchaWidgetId = window.grecaptcha.render(el, {
      sitekey: siteKey,
      callback: (token) => {
        this.googleRecaptchaToken = token || ''
        if (this.pendingSendOtpAfterRecaptcha && this.googleRecaptchaToken) {
          this.pendingSendOtpAfterRecaptcha = false
          this.showRecaptcha = false
          this.doSendOtp()
        }
      },
      'expired-callback': () => {
        this.googleRecaptchaToken = ''
      },
      'error-callback': () => {
        this.googleRecaptchaToken = ''
      },
    })
  },

  openRecaptchaForSendOtp () {
    this.pendingSendOtpAfterRecaptcha = true
    this.googleRecaptchaToken = ''
    this.showRecaptcha = true
    this.$nextTick(() => {
      this.renderGoogleRecaptcha('6LdxU8ssAAAAAM-_00DGvK0JXmMC3EpkYLo1N66P')
    })
  },

  closeRecaptcha () {
    this.pendingSendOtpAfterRecaptcha = false
    this.showRecaptcha = false
  },

  doSendOtp () {
    if (!this.timer && this.count === null) {
      sendVerCodeV2(this.userName,this.phoneNo,this.passwd,this.inviteCode,this.captcha.trim(),this.captchaToken,this.googleRecaptchaToken).then(res => {
            if ('000000' === res.code) {
                this.count = 60;
                this.timer = setInterval(() => {
                this.count -= 1;
                if (this.count == 0) {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.count = null;
                }
                }, 1000);
            }else{
              alert(res.msg);
              this.loadCaptcha();
            }
    })
    }
  },

  loadCaptcha () {
    if (this.captchaImageUrl) {
      URL.revokeObjectURL(this.captchaImageUrl)
      this.captchaImageUrl = ''
    }
    this.captcha = ''
    getCaptcha().then((res) => {
      this.captchaToken = res.captchaToken
      this.captchaImageUrl = URL.createObjectURL(res.blob)
    }).catch(() => {
      alert('Failed to load captcha, please tap Refresh')
    })
  },

  getCode () {
    if(!this.phoneNo){
      alert("Please enter your phone number");
      return;
    }
    if(!this.passwd){
      alert("Please enter your passwd");
      return;
    }
    if(!this.inviteCode){
      alert("Please enter your inviteCode");
      return;
    }
    if(!this.captcha || !String(this.captcha).trim()){
      alert("Please enter image code");
      return;
    }
    if(!this.captchaToken){
      alert("Captcha expired, please refresh image code");
      this.loadCaptcha();
      return;
    }
    // 每次点击 Send 都要求重新进行 Google reCAPTCHA 校验
    this.openRecaptchaForSendOtp()
    return
  },
  submitData(){

    if(!this.phoneNo){
      alert("Please enter your phone number");
      return;
    }
    if(!this.passwd){
      alert("Please enter your passwd");
      return;
    }
    if(!this.inviteCode){
      alert("Please enter your inviteCode");
      return;
    }
    if(!this.smsOtp){
      alert("Please enter your smsOtp");
      return;
    }
    if(!this.captcha || !String(this.captcha).trim()){
      alert("Please enter image code");
      return;
    }
    if(!this.captchaToken){
      alert("Captcha expired, please refresh image code");
      this.loadCaptcha();
      return;
    }
    if(!this.googleRecaptchaToken){
      alert("Please send otp code first");
      return;
    }


    registerUser(this.userName,this.phoneNo,this.passwd,this.inviteCode,this.smsOtp,this.captcha.trim(),this.captchaToken,this.googleRecaptchaToken).then(res => {
            if ('000000' === res.code && res.data) {
              this.h5Url=res.data.h5DownloadUrl;
              this.submitPass=true;
            }else{
              alert(res.msg);
              this.loadCaptcha();
            }
    })
  }


 }


}


</script>

<style scope lang="scss">
.app {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  box-sizing: border-box;
  /* background: linear-gradient(180deg, #6a68ff 0%, #30c8f6 100%); */
  background: url('./assets/img/bg.png') no-repeat;
  background-size: 100% 100%;
  header{
    text-align: center;
    margin: 20px 0;
    img{
      width: 157px;
    }
  }
  .content{
    max-width: 500px;
    margin: 50px auto;
    .item{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 5%;
      width: 90%;
      box-sizing: border-box;
      background: #fff;
      border-radius: 30px;
      height: 46px;
      margin-bottom: 40px;
      font-size: 14px;
      position: relative;
      overflow: hidden;
      
      img{
        width: 26px;
        margin-left: 15px;
      }
      input{
        flex: 1;
        border-left: 1px solid #e5e5e5;
        margin-left: 10px;
        padding: 3px 15px 3px 12px;
        font-size: 14px;
        &::-webkit-input-placeholder{
          font-size: 14px;
        }
      }
      a{
        flex: 1;
        color: #fff;
        text-align: center;
      }
      span{
        background: #6950FB;
        color: #fff;
        position:sticky;
        right: 0;
        top: 0;
        width: 70px;
        line-height: 46px;
        text-align: center;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        height: 46px;
        cursor: pointer;
      }
      &:first-child{
        input{
          border-left: none;
          margin-left: 5px;
          padding-left: 5px;
        }
      }
      &:last-child{
        justify-content: center;
        background: #6950FB;
        cursor: pointer;
        color: #fff;
        font-size: 16px;
      }
      .disabled{
        cursor: not-allowed;
      }
    }
    .mb5{
      margin-bottom: 5px;
    }
    .tip {
      margin-left: 15%;
      margin-bottom: 15px;
      color: #FFFFFF;
    }
    .imageCode {
      .row-icon {
        flex-shrink: 0;
        width: 26px;
        height: 26px;
        object-fit: contain;
      }
      input {
        min-width: 0;
      }
      .captcha-side {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        height: 100%;
        background: #f5f5f5;
        border-left: 1px solid #e5e5e5;
      }
      .captcha-img {
        width: auto;
        min-width: 88px;
        max-width: 120px;
        height: 40px;
        margin: 0 0 0 4px;
        object-fit: contain;
        cursor: pointer;
        user-select: none;
      }
      .captcha-refresh {
        position: static;
        width: 72px;
        flex-shrink: 0;
        line-height: 46px;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        border-radius: 0;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
      }
    }
    .optCode{
      span{
        background-color: #6950FB;
        color: #fff;
        font-weight: 700;
        width: 100px;
        flex-shrink: 0;
        cursor: pointer;
        user-select: none;
      }
      .disabled{
        background-color: #6a50fbd2;
        cursor: not-allowed;
      }
    }
  }

  .recaptcha-modal {
    position: fixed;
    inset: 0;
    z-index: 9999;

    .recaptcha-mask {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.55);
    }

    .recaptcha-panel {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: min(92vw, 380px);
      background: #fff;
      border-radius: 14px;
      padding: 16px 14px 12px;
      box-sizing: border-box;
    }

    .recaptcha-title {
      font-size: 15px;
      font-weight: 700;
      color: #111;
      margin-bottom: 12px;
      text-align: center;
    }

    .recaptcha-container {
      display: flex;
      justify-content: center;
      padding: 2px 0 8px;
    }

    .recaptcha-actions {
      display: flex;
      justify-content: center;
      margin-top: 6px;
    }

    .recaptcha-btn {
      border: none;
      outline: none;
      height: 36px;
      padding: 0 18px;
      border-radius: 18px;
      font-size: 14px;
      cursor: pointer;
    }

    .recaptcha-btn.cancel {
      background: #f2f2f2;
      color: #333;
    }
  }
}
</style>
